var map = {
	"./balraj.webp": 44252,
	"./geetha.webp": 19402,
	"./karthikeyan.webp": 26911,
	"./kowshalya.webp": 5083,
	"./krishnamoorthy.webp": 84318,
	"./krishnaveni.webp": 3758,
	"./manikandan.webp": 23242,
	"./manjularani.webp": 66978,
	"./nirmaladevi.webp": 97966,
	"./palanisamy.webp": 66287,
	"./prabhakaran.webp": 63187,
	"./revathi.webp": 24979,
	"./sathishkumar.webp": 70456,
	"./srinivasan.webp": 56386,
	"./tamilsai.webp": 46938,
	"./yoghananthan.webp": 38616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58532;